import React from 'react'; 
import { useHistory } from 'react-router-dom';
import { TableHeader, EvaluationTableRow, LoadingSpinner } from './index';
import EmptyStateMessage from './EmptyStateMessage'; 
import { useSortedData } from '../hooks/useSortedData';
import { ImpactEvaluationTableProps } from '../types';
import { mapEvaluationData } from '../utils';
import { useState } from 'react';

export const ImpactEvaluationTable: React.FC<ImpactEvaluationTableProps> = ({ userId, rawEvaluations, loadingEvaluations }) => {
  const history = useHistory();
  const [sortType, setSortType] = useState<string>('');
  const evaluations = mapEvaluationData(rawEvaluations);
  const sortedData = useSortedData(evaluations, sortType);

  const handleEvaluationClick = async (index: number, item: any) => { 
    history.push(`/evaluations/${item.idEnrollment}/${item.idEvaluation}/${item.idQuestionnaire}`);
  };

  if (loadingEvaluations) {
    return <LoadingSpinner />;
  }

  if (!evaluations || evaluations.length === 0) {
    return <EmptyStateMessage />;
  }

  return (
    <>
      <table className="responsiveTable">
        <TableHeader sortType={sortType} onSort={setSortType} />
        <tbody>
          {sortedData.length > 0 ? (
            sortedData.map((item, idx) => (
              <EvaluationTableRow
                key={`${item.idQuestionnaire}-${idx}`}
                item={item}
                index={idx}
                onEvaluationClick={handleEvaluationClick}
              />
            ))
          ) : (
            <tr>
              <td colSpan={5} style={{ padding: 0 }}>
                <EmptyStateMessage />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default ImpactEvaluationTable;
